import { Route, Routes } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import ProjectsSection from "./components/ProjectsSection";
import { Helmet } from "react-helmet";
import Culture from "./components/CultureSection";
import Hero from "./components/HeroSection";
import TechnologySection from "./components/TechnologySection";

import TermsPage from "./pages/TermsPage";
import PrivacyPage from "./pages/PrivacyPage";

export default function App() {
  return (
    <>
      <Helmet>
        <title>Omnyx - Innovative Solutions</title>
        <meta
          name="description"
          content="Omnyx provides modern web, mobile, and cloud solutions. Discover innovative tech-driven solutions for your business."
        />
        <meta name="keywords" content="Omnyx, Web Development, Mobile Apps, Tech Consulting, Cloud Integration, UI/UX, Cybersecurity, Ingroove" />
        <meta name="author" content="Omnyx" />
      </Helmet>

      <div className="min-h-screen overflow-x-hidden">
        {/* Subtle film-grain texture, sitewide, to avoid flat/plain surfaces */}
        <div
          aria-hidden="true"
          className="pointer-events-none fixed inset-0 z-[1] opacity-[0.025] mix-blend-multiply"
          style={{
            backgroundImage:
              "url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='180' height='180'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")",
          }}
        />

        <Header />

        <Routes>
          {/* Home Page */}
          <Route
            path="/"
            element={
              <>
                <Hero />
                <ProjectsSection />
                <TechnologySection />
                <Culture />
              </>
            }
          />

          {/* Legal Pages: light theme, matching the rest of the site */}
          <Route
            path="/terms"
            element={
              <div className="min-h-screen bg-site-page">
                <TermsPage />
              </div>
            }
          />
          <Route
            path="/privacy"
            element={
              <div className="min-h-screen bg-site-page">
                <PrivacyPage />
              </div>
            }
          />
        </Routes>

        <Footer />
      </div>
    </>
  );
}

